import {
  CoreButton,
  CoreModal,
  CoreUploader
} from '@komodo-design-system/komodo-components-react';
import {
  CoreModalCustomEvent,
  UploadedFile
} from '@komodo-design-system/komodo-core-web-components';
import { isEmpty } from 'lodash-es';
import { findElementByPrompt } from 'utils/utils';

interface checkInProps {
  uploadFile: (event: CustomEvent<UploadedFile[]>) => void;
  files: UploadedFile[];
  setFiles: (files: UploadedFile[]) => void;
  handleSubmit?: (e: React.MouseEvent<any>) => void;
  handleCheckIn: (event: CoreModalCustomEvent<any>) => void;
  assetDetails?: any;
}
const CheckIn = ({
  uploadFile,
  files,
  setFiles,
  handleSubmit,
  handleCheckIn,
  assetDetails
}: checkInProps) => {
  // get display_value from assetDetails for field_id ARTESIA.FIELD.ASSET NAME
  const name =
    findElementByPrompt(assetDetails, 'Name')?.value?.display_value ||
    'Asset Name Not Found';
  const version =
    findElementByPrompt(assetDetails, 'Asset Version')?.value?.display_value ||
    '1.0';
  const fileType =
    findElementByPrompt(assetDetails, 'Mime Type')?.value?.display_value || '';
  return (
    <div className="check-in-container">
      <CoreModal
        isopen
        onModalClosedTrigger={handleCheckIn}
        bgclose={false}
        closeicon={false}
        header="Check In Asset">
        <div className="check-in-content">
          <div className="checked-out-file">
            <p className="check-in-instruction">Checked out file</p>
            <div>
              {/* <span className="icon-24-docs-pdf-bold"></span> */}
              <label>File name</label>
              <span className="file-name">{name}</span>
            </div>
            <div>
              <label>File Type</label>
              <span className="file-name">{fileType}</span>
            </div>
            <div>
              <label>Asset Version</label>
              <span className="file-name">{version}</span>
            </div>
          </div>
          {/* <div></div> */}
          <div style={{ width: '50%' }}>
            <p className="check-in-instruction">
              Please upload the file you want to check in.
            </p>
            <CoreUploader
              className={files.length > 0 ? 'uploader' : ''}
              files={files}
              limitone
              showicon
              // variant="full-size"
              onFileListUpdated={uploadFile}
              closeFileCallback={() => setFiles([])}></CoreUploader>
            <div className="action-buttons">
              <CoreButton label="Submit" onClick={handleSubmit} disabled={isEmpty(files)}></CoreButton>
              <CoreButton
                label="Cancel"
                variant="outline"
                onClick={() =>
                  handleCheckIn({} as CoreModalCustomEvent<any>)
                }></CoreButton>
            </div>
          </div>
        </div>
      </CoreModal>
    </div>
  );
};

export default CheckIn;
